/** Lesson word → review card, with the sentence from the text it appears in. */
import type { Lesson, Word } from '../../core/content.ts';
import { findSentence, langCode } from '../../core/content.ts';
import type { NewCard } from '../../state/app-data.tsx';

export function wordToCard(lesson: Lesson, word: Word): NewCard {
  const sentence = word.exampleSentenceId ? findSentence(lesson, word.exampleSentenceId) : undefined;
  return {
    kind: 'word',
    ref_id: word.id,
    lang: langCode(lesson.targetLang),
    front: {
      text: word.word,
      ...(word.pinyin ? { pinyin: word.pinyin } : {}),
      ...(sentence ? { sentence: sentence.text } : {}),
    },
    back: { ru: word.ru, pos: word.pos, ...(sentence ? { sentenceRu: sentence.ru } : {}) },
  };
}
